import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import {control} from'../react/control'
import Icon from './Icon'
import style from './Tags.less'

class Tags extends Component {
    static propTypes = {
        display: PropTypes.func,
        active: PropTypes.func,
        label: PropTypes.string,
        labelClassName: PropTypes.string,
        wrapperClassName: PropTypes.string,
        value: PropTypes.array.isRequired,
        onChange: PropTypes.func.isRequired
    }

    static defaultProps = {
        display: (v) => v,
        active: (v) => true
    }

    _remove(tag) {
        const {value, onChange} = this.props
        const index = value.indexOf(tag)

        if (index >= 0) {        
            var nextValue = [...value]
            nextValue.splice(index, 1)
            onChange(nextValue)
        }
    }

    render() {
        const {display, active, label, labelClassName, wrapperClassName, value, onChange, ...other} = this.props

        return (
            <div className={style.default}>
                {label && value.length > 0 && (
                    <label className={labelClassName}>
                        {label}
                    </label>
                )}
                <ul className={wrapperClassName}>
                    {value.map((tag) => (
                        <li
                            key={display(tag)}
                            className={cx({[style.active]: active(tag)})}
                            onClick={() => this._remove(tag)}>
                            <a>
                            	<Icon icon='cross' size='xs' />
                            	{display(tag)}
                            </a>
                        </li>                    
                    ))}
                </ul>
            </div>
        )
    }
}

Tags = control({
    value: []
})(Tags)

export default Tags


// WEBPACK FOOTER //
// ./lib/core/components/Tags.js